module.exports = __webpack_public_path__ + "static/media/dollar.9af76399.svg";